var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWalletAdd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8847 12.8654H7.71802",
    stroke: "#2948CE",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.80151 10.8317V14.9984",
    stroke: "#2948CE",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.55 2.09844L10.525 2.15677L8.1083 7.7651H5.7333C5.16663 7.7651 4.62497 7.88177 4.1333 8.0901L5.59163 4.60677L5.62497 4.52344L5.6833 4.3901C5.69997 4.3401 5.71663 4.2901 5.74163 4.24844C6.8333 1.72344 8.06663 1.14844 10.55 2.09844Z",
    stroke: "#2948CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0417 7.93178C14.6667 7.81512 14.2667 7.76512 13.8667 7.76512H8.1084L10.5251 2.15678L10.5501 2.09845C10.6751 2.14012 10.7917 2.19845 10.9167 2.24845L12.7584 3.02345C13.7834 3.44845 14.5001 3.89012 14.9334 4.42345C15.0167 4.52345 15.0834 4.61512 15.1417 4.72345C15.2167 4.84012 15.2751 4.95678 15.3084 5.08178C15.3417 5.15678 15.3667 5.23178 15.3834 5.29845C15.6084 5.99845 15.4751 6.85678 15.0417 7.93178Z",
    stroke: "#2948CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9348 11.832V13.457C17.9348 13.6236 17.9265 13.7903 17.9182 13.957C17.7598 16.8653 16.1348 18.332 13.0515 18.332H6.55151C6.35151 18.332 6.15151 18.3153 5.95985 18.2903C3.30985 18.1153 1.89318 16.6986 1.71818 14.0486C1.69318 13.857 1.67651 13.657 1.67651 13.457V11.832C1.67651 10.157 2.69318 8.71529 4.14318 8.09029C4.64318 7.88196 5.17651 7.76529 5.74318 7.76529H13.8765C14.2848 7.76529 14.6848 7.82362 15.0515 7.93196C16.7098 8.44029 17.9348 9.99029 17.9348 11.832Z",
    stroke: "#2948CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.59175 4.60678L4.13341 8.09011C2.68341 8.71511 1.66675 10.1568 1.66675 11.8318V9.39011C1.66675 7.02345 3.35008 5.04845 5.59175 4.60678Z",
    stroke: "#2948CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9322 9.38972V11.8314C17.9322 9.99806 16.7155 8.43972 15.0488 7.93972C15.4822 6.85639 15.6072 6.00639 15.3988 5.29806C15.3822 5.22306 15.3572 5.14806 15.3238 5.08139C16.8738 5.88139 17.9322 7.52306 17.9322 9.38972Z",
    stroke: "#2948CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletAdd);
export default __webpack_public_path__ + "static/media/wallet-add.091a1107284fbb19c95573f64f7432c1.svg";
export { ForwardRef as ReactComponent };